
/* eslint-disable */
import {
  GET_ALL_LOOKUPS_SUCCESS,
  MODULE,
} from './constants';

const INIT_STATE = {
  module: MODULE,
  approvalLevelList:[],
  rolesList:[],
  contactList:[],
  lookupData: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALL_LOOKUPS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
